import { Box, Drawer, List, Divider, ListItem, ListItemButton, ListItemText, ListItemIcon, Tooltip } from '@mui/material';

import { useEffect, useState } from "react";
import { useExportS2sReport } from '../../api/vegApl';
import { useWeightScale } from '../../hooks/useWeightScale';
import { useSnackbar } from '../../contexts/SnackbarContext';

import { useNavigate, useLocation } from "react-router-dom"
// import { useGlobalState } from "../../contexts/GlobalState";




interface DrawerMenuProps {
    userName?: string;
    onMenuClick?: () => void;
    menuArr: any[];
    open: boolean,
    handleDrawerClose?: () => void;
    position: "left" | "right" | "top" | "bottom";
    backGround: string,
    backDrops: boolean,
    variant: "temporary" | "permanent" | "persistent" | undefined,
    topZero: boolean,
    isCollapsible: boolean,

    moduleName: string

}

// const drawerWidth = 240;
const DrawerMenu = ({ menuArr, open, handleDrawerClose, position = "right", backGround, backDrops, variant = "temporary", topZero, isCollapsible, moduleName }: DrawerMenuProps) => {

    const navigate = useNavigate();

    const { isSupported: scaleSupported, connected: scaleConnected, connect: doConnectScale } = useWeightScale();
    const { showSnackbar } = useSnackbar();

    const [scrollTop, setScrollTop] = useState(0);
    const [width, setWidth] = useState(isCollapsible ? 80 : 288);
    const buildTodayFileName = (prefix: string) => {
        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        return `${prefix}-${yyyy}-${mm}-${dd}`;
    };

    const downloadBlobWithName = (blobData: any, fileName: string) => {
        const blob = blobData instanceof Blob
            ? blobData
            : new Blob([blobData]);

        const href = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(href);
    };

    const { mutate: exportS2sReportMutate } = useExportS2sReport({
        mutation: {
            onSuccess: (response: any) => {
                downloadBlobWithName(response?.data, `${buildTodayFileName('s2s-report')}.xlsx`);
                handleDrawerClose && handleDrawerClose();
            },
            onError: (error: any) => {
                console.error('Failed to download report', error);
                handleDrawerClose && handleDrawerClose();
            },
        },
    });

    const handleFileDownload = (downloadUrl: string) => {
        if (downloadUrl === '/api/v1/s2s-export') {
            exportS2sReportMutate();
            return;
        }

        console.error(`Unsupported downloadUrl in menu: ${downloadUrl}`);
        handleDrawerClose && handleDrawerClose();
    };

    const handleMenuItemClick = (item: { routePath?: string; externalUrl?: string; downloadUrl?: string; action?: string }) => {
        if (item?.action === 'connect-scale') {
            if (!scaleSupported) {
                showSnackbar({ message: 'Scale connection needs Chrome or Edge', severity: 'warning' });
                return;
            }
            // requestPort() needs this click's gesture, so nothing may be awaited before it.
            doConnectScale().then((ok) => {
                if (ok) {
                    showSnackbar({ message: 'Scale connected', severity: 'success' });
                    handleDrawerClose && handleDrawerClose();
                }
            });
            return;
        }
        if (item?.externalUrl) {
            window.open(item.externalUrl, "_blank", "noopener,noreferrer");
            handleDrawerClose && handleDrawerClose();
            return;
        }
        if (item?.downloadUrl) {
            handleFileDownload(item.downloadUrl);
            return;
        }
        if (item?.routePath) {
            navigate(item.routePath);
            handleDrawerClose && handleDrawerClose();
        }
    }
    const location = useLocation();
    useEffect(() => {
        const handleScroll = () => {
            setScrollTop(window.pageYOffset);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [])

    const toggleSize = (size: number) => {
        isCollapsible && setWidth(size);
    }
   
    return (
        <Drawer
            sx={{
                width: width,
                flexShrink: 0,

                "& .MuiDrawer-paper": {
                    width: width,
                    boxSizing: "border-box",
                    backgroundColor: backGround,
                    marginTop: topZero && scrollTop > 65 ? "0px" : "64px",

                },
            }}
            variant={variant}
            anchor={position}
            open={open}
            onClose={handleDrawerClose && handleDrawerClose}
            ModalProps={{
                keepMounted: true,
                BackdropProps: backDrops
                    ? {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            marginTop: "64px",
                        },
                    }
                    : undefined,
            }}

            slotProps={{
                paper: {

                    onMouseEnter: () => toggleSize(288),
                    onMouseLeave: () => toggleSize(80)


                },
            }}>
            <Box sx={{ height: 0, minHeight: 0 }}>
                <List>
                    {Object.entries(menuArr).map(([groupName, items], groupIndex) => (
                        <Box key={groupName} sx={{ mr: 3 }}>
                            {items.map((item: any, index: number) => (
                                <ListItem key={index} disablePadding sx={{ backgroundColor: !item?.externalUrl && location.pathname.includes(item?.routePath) && width == 288 ? "#EEF8ED" : "transparent" }}>
                                    <Tooltip title={item?.disabled ? "Page not ready. Under development." : ""} arrow placement="right">
                                        <Box component="span" sx={{ width: '100%' }}>
                                    <ListItemButton disableRipple disabled={item?.disabled || (item?.action === 'connect-scale' && scaleConnected)} onClick={() => handleMenuItemClick(item)} sx={{

                                        '&:hover': {
                                            backgroundColor: width == 288 ? "#EEF8ED" : "transparent"
                                        },
                                    }}>
                                        {item.icon && (
                                            <Box sx={{
                                                ...(!item?.externalUrl && location.pathname.includes(item?.routePath) && width === 80 && {
                                                    backgroundColor: "#CEFFDD",
                                                    borderRadius: "10px"
                                                }),

                                            }}>
                                                <ListItemIcon sx={{

                                                    ...(moduleName === "in-season" && {
                                                        minWidth: "auto", px: 1.8, py: 1.4
                                                    }),

                                                }}

                                                >{item.icon}</ListItemIcon>
                                            </Box>
                                        )}
                                        {
                                            (
                                                (width === 288 && moduleName === "in-season") ||
                                                moduleName === "post-season"
                                            ) &&
                                            <ListItemText
                                                slotProps={{
                                                    primary: {
                                                        sx: {                                                          
                                                            fontWeight: 500,
                                                            fontSize:16,
                                                            color:"#0A0A0A"
                                                        },
                                                    },
                                                }}

                                                primary={item.menuName} />}

                                        {item?.action === 'connect-scale' && scaleConnected && (
                                            <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#00AC4F', flexShrink: 0, ml: 1 }} />
                                        )}

                                    </ListItemButton>
                                        </Box>
                                    </Tooltip>
                                </ListItem>
                            ))}

                            {groupIndex !== Object.entries(menuArr).length - 1 && <Divider sx={{ mb: 2 }} />}
                        </Box>
                    ))}
                </List>
            </Box>
            {/* {isCollapsible && <Avatar
                sx={{
                    width: 40,
                    height: 40,
                    bgcolor: "#FFFFFF",
                    border: `2px solid #D1D5DC`,
                    position: "fixed",
                    left: isCollapased ? 30 : "218px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1300,

                }}
                onClick={() => setCollapased(prev => !prev)}
            >
                <ChevronLeftIcon sx={{ color: '#4A5565', fontSize: 30 }} />
            </Avatar>} */}

        </Drawer>
    )
};
export default DrawerMenu;